// This is generated.  Alter it in blockGroups/workflowCriteriaElements/types/DropDownCriteria.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const distinct = require('lodash/uniq');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    const {
      id,
      title,
      tooltip,
      foreignNamespace,
      foreignRelation,
      dropdownDisplayProperties,
      inputDisplayProperties,
      required = false,
    } = hNode;

    const nestedProperties = distinct([
      ...dropdownDisplayProperties,
      ...inputDisplayProperties,
    ]);

    // Build TypeBox schemas for nested string properties
    const nestedTypeDef = nestedProperties.reduce(
      (soFar, propertyName) => {
        return {
          ...soFar,
          [propertyName]: Type.String({
            title: propertyName,
            'x-dataType': 'string',
            'x-propertyName': propertyName,
          }),
        };
      },
      {
        _id: Type.String({
          title: 'Unique ID',
          'x-dataType': 'string',
          'x-propertyName': '_id',
        }),
      },
    );

    // we could be on an update form, or on a new form, or nested somewhere
    // We just don't know what accessContext this would be enabling, nor how it is applied on a NS/REL
    // Security Modifiers (which would disabled certain accessContext) are processed generically
    // All we know is that Whatever propertyName is on this Criteria block
    // and how it is formatted.

    // Create TypeBox object schemas for _eq and _neq operators
    const eqSchema = Type.Optional(
      Type.Object(nestedTypeDef, {
        title: 'Test for equality',
        'x-dataType': 'object',
        'x-propertyName': '_eq',
        'x-optional': true,
        additionalProperties: false,
        required: ['_id', ...nestedProperties],
      }),
    );

    const neqSchema = Type.Optional(
      Type.Object(nestedTypeDef, {
        title: 'Test for inequality',
        'x-dataType': 'object',
        'x-propertyName': '_neq',
        'x-optional': true,
        additionalProperties: false,
        required: ['_id', ...nestedProperties],
      }),
    );

    // Create main criteria object
    const criteriaSchema = Type.Object(
      {
        _eq: eqSchema,
        _neq: neqSchema,
      },
      {
        'x-id': id,
        title: title,
        'x-tooltip': tooltip,
        'x-propertyName': `${foreignNamespace}:${foreignRelation}`,
        'x-dataType': 'object',
        'x-optional': !required,
        additionalProperties: false,
      },
    );

    const partialTypeDefinition = {
      [`${foreignNamespace}:${foreignRelation}`]: required
        ? criteriaSchema
        : Type.Optional(criteriaSchema),
    };

    return [{}, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType(
  'workflowCriteriaElements',
  'DropDownCriteria',
  module.exports,
);
